import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";
import { useGetTemplateStatisticsQuery } from "../services/statistics";

type StatsData = {
  template_by_type: Record<string, number>;
  passes_by_template_type: Record<string, number>;
};

interface Props {
  stats: StatsData;
}

export default function TemplateStatsDashboard() {

  const { data: stats } = useGetTemplateStatisticsQuery();
  
  if (!stats) {
    return <div>Loading...</div>;
  }

  const templateData = Object.entries(stats.template_by_type).map(([key, value]) => ({
    type: key,
    count: value,
  }));

  const passesData = Object.entries(stats.passes_by_template_type).map(([key, value]) => ({
    type: key,
    count: value,
  }));

  if (!stats) {
    return <div>Loading...</div>;
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-6">
      {/* Templates chart */}
      <div className="p-4 border rounded-2xl shadow-sm bg-white">
        <h2 className="text-xl font-semibold mb-4">Templates by Type</h2>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={templateData}>
            <XAxis dataKey="type" />
            <YAxis />
            <Tooltip />
            <Bar dataKey="count" />
          </BarChart>
        </ResponsiveContainer>
      </div>

      {/* Passes chart */}
      <div className="p-4 border rounded-2xl shadow-sm bg-white">
        <h2 className="text-xl font-semibold mb-4">Passes by Template Type</h2>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={passesData}>
            <XAxis dataKey="type" />
            <YAxis />
            <Tooltip />
            <Bar dataKey="count" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}